export default {
  gestionnaire: {
    fecth: {
      error: 'Impossible de récupérer le gestionnaire dans Essenciem',
    },
  },
}
